module.exports = __webpack_public_path__ + "static/banner-mobile-15735aaf9eefb8d606b1590e31cb2042.png";